import { downloadZip } from 'utils';

export default {
  'InspectionReportAreaTable.Wrapper.HeaderWrapper.HeaderWrapper': ({ isOpen }, _, internalStateSetter) => {
    internalStateSetter({ isOpen: !isOpen });
  },
  'InspectionReportAreaTable.Wrapper.TableWrapper.HeaderRowContainer': () => { },
  'InspectionReportAreaTable.Wrapper.TableWrapper.ColumnNamesRow': () => { },
  'InspectionReportAreaTable.Wrapper.TableWrapper.FooterRowContainer': () => { },
  'InspectionReportAreaTable.Wrapper.TableWrapper.RowContainer': async ({ action, item }, outlet) => {
    if (action === 'download') {
      downloadZip(item.attachments);
    }
    if (action === 'view') {
      outlet({ action: 'view', item })
    }
  }
}